import Lifestyle from './Lifestyle';

export default Lifestyle;
export { Lifestyle };
